import { Days, IWeeklySchedulerItem, IWeeklySchedulerRange } from '@captiveaire/weeklyscheduler';

export class NamedFrameModelWeeklySchedulerItem implements IWeeklySchedulerItem<string> {
    constructor(
        public day: Days,
        public schedules: Array<IWeeklySchedulerRange<string>>
    ) {
    }

    get editable() {
        return true;
    }
}
